export enum ReviewSessionStatusEnum {
  Active = 0,
  Completed = 1,
  Abandoned = 2,
}

export function reviewSessionStatusEnumToLabel(
  status: ReviewSessionStatusEnum
): string {
  switch (status) {
    case ReviewSessionStatusEnum.Active:
      return 'Active';
    case ReviewSessionStatusEnum.Completed:
      return 'Completed';
    case ReviewSessionStatusEnum.Abandoned:
      return 'Abandoned';
  }
}
